export const lineHeight = {
  "sys-0-8": "0.8",
  "sys-0-9": "0.9",
  "sys-0-95": "0.95",
  "sys-1": "1",
  "sys-1-15": "1.15",
  "sys-1-2": "1.2",
  "sys-1-3": "1.3",
};
